export const calculateElapsedRecordingDuration = (
  startTime: number,
  totalPausedTime: number
) => new Date().getTime() - startTime - totalPausedTime;

export const calculatePauseDuration = (
  pauseStartTime: number,
  previousTotalPausedTime: number
) => new Date().getTime() - pauseStartTime + previousTotalPausedTime;
